var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"80vh"}},[_c('editor-content',{staticClass:"editor-container blog",attrs:{"editor":_vm.editor}}),_c('div',{staticClass:"character-count"},[_c('p',[_vm._v(_vm._s(_vm.charCnt)+"/"+_vm._s(_vm.limit))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }